import type { ComponentProps, CSSProperties } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"
import useSidebarContext from "@/v2-backoffice-client/components/sidebar/sidebar.context"

export type SidebarContentProps = ComponentProps<"div"> & {
  width?: string
  miniWidth?: string
}

function SidebarContent(props: SidebarContentProps) {
  const {
    className,
    children,
    width = "10rem",
    miniWidth = "50px",
    style,
    ...divProps
  } = props

  const { isMini, setIsMini } = useSidebarContext()

  const sidebarStyle: CSSProperties = {
    ...style,
    "--sidebar-width": width,
    "--sidebar-mini-width": miniWidth,
  } as CSSProperties

  return (
    <div
      className={cn("sidebar", className, {
        "is-mini": isMini,
      })}
      style={sidebarStyle}
      {...divProps}
    >
      {children}

      <button
        type="button"
        className="sidebar-mini-btn"
        aria-label={isMini ? "Expand sidebar" : "Collapse sidebar"}
        onClick={() => {
          setIsMini(!isMini)
        }}
      >
        <Icon src={isMini ? "angle-small-right" : "angle-small-left"} />
      </button>
    </div>
  )
}

export default SidebarContent
